const SPEAKER_SIGNER_TYPES = {
  SPEAKER: 'سخنران',
  SINGER: 'مداح',
  BOTH: 'مداح/سخنران',
};

enum OCCASION {
  Sorrow = 'SORROW',
  Happiness = 'HAPPINESS',
  Other = 'OTHER',
}

const IDS_ERRORS = {
  invalid_username_or_password: 'نام کاربری یا رمز‌عبور اشتباه است.',
};

const UPLOAD_ERRORS = {
  'file-too-large': 'حجم فایل ارسالی بیشتر از حجم تعیین شده است.',
  'file-invalid-type': 'فرمت فایل ارسالی باید jpeg یا png باشد.',
  'file-invalid-type-video':
    'فرمت فایل ارسالی باید 3gp, mpg, mpeg, mkv, wmv, mp4 باشد.',
};

const CONVERSATION_TYPES = {
  ALL: 'همه پیام‌ها',
  SEEN: 'خوانده شده',
  UNSEEN: 'خوانده نشده',
  BOOKMARKED: 'ستاره دار',
};

const VIOLATION_TYPES = {
  HEYAT_ALBUM: 'گالری تصاویر',
  HEYAT_VIDEO: 'ویدیو',
  HEYAT: 'پخش زنده هیئت',
  HARAM: 'حرم آنلاین',
  QURAN: 'قرآن آنلاین',
  ARCHIVE: 'آرشیو',
};

const NOTICE_TYPES = {
  BOTH: 'نوتیفیکشن/ پیامک',
  FIREBASE: 'نوتیفیکشن',
  SMS: 'پیامک',
};

const PROCESS_STATUS_TYPES = {
  NOT_PROCESSED: 'پردازش نشده',
  PROCESSING: 'در حال پردازش',
  FAILED_PROCESSED: 'پردازش شده ناموفق',
  PROCESS_FORMATS: 'پردازش فرمت ها',
  SUCCESS_FULL_PROCESSED: 'پردازش شده موفق',
  BIG_FILE_DETECTED: 'فایل بزرگ حذف شده',
  BIG_FILE_CONFIRMED: 'فایل بزرگ تایید شده',
  BIG_FILE_REJECTED: 'فایل بزرگ رد شده',
  PENDING_FOR_STOP_RECORD: 'در حال مرج',
  PENDING_FOR_MERGE: 'در حال مرج',
};

const PROCESS_STEPS_TYPES = {
  STEP_0: 'صف آرشیو',
  STEP_1: 'آماده سازی آرشیو',
  STEP_2: 'آماده سازی آرشیو',
  STEP_3: 'پردازش آرشیو',
  STEP_4: 'نهایی سازی آرشیو',
  STEP_5: 'نهایی سازی آرشیو',
  STEP_6: 'آرشیو شد',
};

const ADVERTISEMENT_ROWS = {
  1: 'اول',
  2: 'دوم',
  3: 'سوم',
};

const ADVERTISEMENT_COLS = {
  1: 'راست',
  2: 'چپ',
};

const EXTERNAL_LIVE_DEFAULT_DELAY_SECONDS = 5;

const ROLES = {
  SuperAdmin: '1df229d5-6817-4590-97a8-7836a47872c7',
  HeyatAdmin: '1e937a5b-d403-514a-ec7d-45b464d34188',
  NewsAdmin: '420ab1e1-8e65-39c3-5ef8-17151cd0f4a5',
  User: '9417c8dc-b241-4f38-ae6c-7368dc7450d8',
  Admin: 'c87840d3-5014-6150-3731-f781b8bac246',
};

const ADVERTISEMENT_TYPE_NAMES = {
  MOBILE_VIEW_UNDER_PROGRAMS: 'زیربرنامه موبایل',
  WEB_HEADER: 'هدر وب',
  WEB_UNDER_PROGRAMS: 'زیربرنامه وب',
};

export {
  SPEAKER_SIGNER_TYPES,
  OCCASION,
  IDS_ERRORS,
  UPLOAD_ERRORS,
  CONVERSATION_TYPES,
  VIOLATION_TYPES,
  NOTICE_TYPES,
  PROCESS_STATUS_TYPES,
  PROCESS_STEPS_TYPES,
  ADVERTISEMENT_ROWS,
  ADVERTISEMENT_COLS,
  EXTERNAL_LIVE_DEFAULT_DELAY_SECONDS,
  ROLES,
  ADVERTISEMENT_TYPE_NAMES,
};
